import script from "./HistorialNavegacion.vue?vue&type=script&setup=true&lang=js"
export * from "./HistorialNavegacion.vue?vue&type=script&setup=true&lang=js"

import "./HistorialNavegacion.vue?vue&type=style&index=0&id=3fa1be72&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fa1be72"]])

export default __exports__